import React from 'react'
import { Select, SelectProps } from '@pushly/aqe/lib/components'
import { SegmentDto } from '../../dtos/segment'
import { getAudienceSegmentOptionGroups } from '../../_utils/segment-list'
import classnames from 'classnames'
import { CheckOutlined } from '@ant-design/icons'

export function SegmentSelect({
    options,
    onChange,
    onDropdownVisibleChange,
    loading,
    segments,
    ...props
}: SelectProps & { segments: SegmentDto[] }) {
    return (
        <div>
            <Select
                {...props}
                loading={loading}
                disabled={loading || props.disabled}
                allowClear={true}
                mode="multiple"
                className={classnames(props.className, 'segment-filter-select')}
                placeholder={props.placeholder ?? 'Select Segments'}
                popupClassName={'segment-filter-select-dropdown'}
                prefix="Segments"
                tagStyle="ghost"
                options={getAudienceSegmentOptionGroups(segments ?? [], 'options')}
                dropdownMatchSelectWidth={false}
                onChange={onChange}
                onDropdownVisibleChange={onDropdownVisibleChange}
            />
        </div>
    )
}
